import React from "react";
import { useSortable } from "@dnd-kit/sortable";

function DNDKitSortableList({ id, children, handleRemoveAsset }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });
  const style = transform
    ? { transform: `translate(${transform.x}px, ${transform.y}px)` }
    : undefined;

  return (
    <div className="space-y-2" ref={setNodeRef} style={style}>
      <div className="mb-2 flex items-center justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div
          className="flex flex-1 items-center"
          {...attributes}
          {...listeners}
        >
          <div className="ml-2 flex-1">
            <p className="font-medium">{children.AssetName}</p>
            <p className="truncate text-sm text-gray-500">{children.Caption}</p>
            <p className="text-xs text-gray-400">{children.BrandName}</p>
          </div>
        </div>
        <button
          onClick={() => handleRemoveAsset(children.AssetID)}
          className="ml-4 rounded-md px-3 py-1 text-sm text-red-600 transition-colors hover:bg-red-50 hover:text-red-800"
        >
          Remove
        </button>
      </div>
    </div>
  );
}

export default DNDKitSortableList;
